import { gql } from '@apollo/client/core';

export const GATEWAY_SETTLEMENT_ACCOUNT_FIELDS = gql`
  fragment GatewaySettlementAccountFields on GatewaySettlementAccount {
    id
    school_id
    payment_provider_id
    label
    gateway_identifier
    config
    bank_name
    account_number
    account_name
    is_default
    is_active
    metadata
    created_at
    updated_at
    paymentProvider {
      id
      name
    }
  }
`;

export const GET_GATEWAY_SETTLEMENT_ACCOUNTS = gql`
  query GetGatewaySettlementAccounts($payment_provider_id: ID) {
    gatewaySettlementAccounts(payment_provider_id: $payment_provider_id) {
      ...GatewaySettlementAccountFields
    }
  }
  ${GATEWAY_SETTLEMENT_ACCOUNT_FIELDS}
`;

export const CREATE_GATEWAY_SETTLEMENT_ACCOUNT = gql`
  mutation CreateGatewaySettlementAccount($input: CreateGatewaySettlementAccountInput!) {
    createGatewaySettlementAccount(input: $input) {
      ...GatewaySettlementAccountFields
    }
  }
  ${GATEWAY_SETTLEMENT_ACCOUNT_FIELDS}
`;

export const UPDATE_GATEWAY_SETTLEMENT_ACCOUNT = gql`
  mutation UpdateGatewaySettlementAccount($input: UpdateGatewaySettlementAccountInput!) {
    updateGatewaySettlementAccount(input: $input) {
      ...GatewaySettlementAccountFields
    }
  }
  ${GATEWAY_SETTLEMENT_ACCOUNT_FIELDS}
`;

export const DELETE_GATEWAY_SETTLEMENT_ACCOUNT = gql`
  mutation DeleteGatewaySettlementAccount($id: ID!) {
    deleteGatewaySettlementAccount(id: $id)
  }
`;

export const SET_DEFAULT_GATEWAY_SETTLEMENT_ACCOUNT = gql`
  mutation SetDefaultGatewaySettlementAccount($id: ID!) {
    setDefaultGatewaySettlementAccount(id: $id) {
      ...GatewaySettlementAccountFields
    }
  }
  ${GATEWAY_SETTLEMENT_ACCOUNT_FIELDS}
`;

export const GET_CHECKOUT_GROUPS = gql`
  query GetCheckoutGroups($bill_id: ID!) {
    checkoutGroups(bill_id: $bill_id) {
      settlement_account {
        id
        label
        gateway_identifier
        bank_name
        account_number
      }
      details {
        id
        item_name
        net_amount
        balance
      }
      subtotal
    }
  }
`;
